/**
 * The packages an admin may move a business onto: published, and from the business's OWN
 * catalog only — its reseller's, or the platform's for a direct business.
 *
 * The admin plan pickers ("No-charge override", "Upgrade & invoice") used to list every published
 * package from every catalog, unlabelled. On prod "Regular" showed three times at three catalogs'
 * prices and "Ultimate ৳12,000" three times identically (2026-09-12), so an admin could not tell
 * which one was the customer's. The API enforces the same rule.
 */
export function ownCatalogPackages<T extends { status: string; catalogResellerId?: string | null }>(
  packages: readonly T[],
  businessResellerId: string | null | undefined,
): T[] {
  const own = businessResellerId ?? null;
  return packages.filter((p) => p.status === 'published' && (p.catalogResellerId ?? null) === own);
}
